export function resetVisibility(nodeEl: HTMLElement): void {
  // Remove the __hide and __show classes from nodeEl
  nodeEl?.classList.remove('__hide');
  nodeEl?.classList.remove('__show');

  // Remove the __hide and __show classes from all children of nodeEl
  nodeEl?.querySelectorAll('.__hide').forEach((el) => el.classList.remove('__hide'));
  nodeEl?.querySelectorAll('.__show').forEach((el) => el.classList.remove('__show'));
}
